export const PASSWORD_REQUIREMENTS = [
  { key: "authentication.password_req.length", test: (p) => p.length >= 8 },
  { key: "authentication.password_req.uppercase", test: (p) => /[A-Z]/.test(p) },
  { key: "authentication.password_req.lowercase", test: (p) => /[a-z]/.test(p) },
  { key: "authentication.password_req.number", test: (p) => /\d/.test(p) },
  { key: "authentication.password_req.special", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export const isStrongPassword = (password) =>
  PASSWORD_REQUIREMENTS.every((r) => r.test(password));
